<template>
	<section class="external-container pc-wrap">
		<div class="header">
			<div class="header-inner">
				<span>{{ isDetail ? '用工详情' : '用工申请'}}</span>
				<span class="header-bizId">单号：{{ applyData.bizId || 'NEW' }}</span>
			</div>
		</div>
		<el-form ref="applyData"  :model="applyData">
			<div class="content" style="padding-top:58px">
				<!-- 用工类型 -->
				<div class="con-filed one-filed">
					<div class="con-title">用工类型</div>
					<div class="con-list">
						<ul>
							<li>
								<div class="inline-filed">
									<el-form-item prop="company" label="合同主体：" :rules="[{
										required: true, message: '合同主体不能为空'}]">
										<el-select v-model="applyData.company" v-if="!isDetail" :disabled="isDetail" placeholder="请选择合同主体"
										@change="changeCompany(applyData.company)">
											<el-option
												v-for="item in companyTypeList"
												:key="item.companyCode"
												:label="item.companyName"
												:value="item.companyCode">
											</el-option>
										</el-select>
										<el-input disabled v-model="applyData.companyDescr" v-else></el-input>
									</el-form-item>
								</div>
							</li>
							<li>
								<div class="inline-filed">
									<el-form-item prop="emplTypeDescr" label="人员类别：" :rules="[{
										required: true, message: '人员类别不能为空', trigger: 'change'}]" >
										<!-- <Select v-model="applyData.emplType" :disabled="isDetail" placeholder="请选择人员类别" @on-change="empTypeChange(applyData.emplType)" v-if="!isDetail">
											<Option v-for="item in emplTypeList" :value="item.value" :label="item.label" :key="item.value">{{ item.label }}</Option>
										</Select> -->
										<el-select
											v-model="applyData.emplType"
											v-if="!isDetail"
											@change="empTypeChange"
											:disabled="isDetail"
											value-key="emplTypeCode"
											placeholder="请选择人员类别">
											<el-option
												v-for="item in emplTypeList"
												:key="item.emplTypeCode"
												:label="item.emplTypeName"
												:value="item.emplTypeCode">
											</el-option>
										</el-select>
										<el-input disabled v-model="applyData.emplTypeDescr" v-else></el-input>
									</el-form-item>
								</div>
							</li>
						</ul>
					</div>
				</div>
				<!-- 基本信息 -->
				<div class="con-filed">
					<div class="con-title">基本信息</div>
					<BaseInfo
						ref="baseInfo"
						v-model="initData"
						:applyData="applyData"
						:isDetail="isDetail"
						@getBaseCheck="getBaseCheck"
						@isCheckId="checkId"
						@changeData="changeBaseInfo"></BaseInfo>
				</div>
				<!-- 任职信息 -->
				<div class="con-filed">
					<div class="con-title">任职信息</div>
					<JobInfo 
						ref="JobInfo"
						v-model="initData"
						@getJobCheck="getJobCheck"
						:isMobile="isMobile"
						:isDetail="isDetail"
						:applyData="applyData"
						:emplTypeTransCode="emplTypeTransCode"
						:socailFlag="socailFlag"
						@select="getIsSubsidyFlag"
						@changejobData="changeJobInfo"></JobInfo>
				</div>
				<!-- 现金收入 -->
				<div class="con-filed" v-if="isShowPay || (isDetail && !(applyData.basePay === '0.00' || !applyData.basePay))">
					<div class="con-title">现金收入和期权</div>
					<div class="con-list">
						<ul>
							<li>
								<div class="inline-filed">
									<el-form-item prop="basePay" label="基本工资：" :rules="[{required: true, message: '基本工资不能为0'}]">
										<el-input v-model="applyData.basePay" :disabled="isDetail" @change="numToFixed(applyData.basePay,'basePay')" placeholder="0.00"></el-input>
									</el-form-item>
								</div>
								<div class="inline-filed">
									<el-form-item label="绩效工资：">
										<el-input v-model="applyData.perfomPay" :disabled="isDetail" @change="numToFixed(applyData.perfomPay,'perfomPay')" placeholder="0.00"></el-input>
									</el-form-item>
								</div>
							</li>
							<li>
								<div class="inline-filed">
									<el-form-item label="月工资合计：">
										<el-input disabled :value="!isDetail ? allCount : applyData.totalPay " ></el-input>
									</el-form-item>
								</div>
								<div class="inline-filed">
									<el-form-item prop="yearBonusNum" label="目标年终奖：">
										<el-select v-model="applyData.yearBonusNum" v-if="!isDetail" :disabled="isDetail" placeholder="请选择目标年终奖">
											<el-option
												v-for="item in yearBonusMonthNumList"
												:key="item.value"
												:label="item.label"
												:value="item.value">
											</el-option>
										</el-select>
										<el-input disabled v-model="applyData.yearBonusNumDescr" v-else></el-input>
									</el-form-item>
								</div>
							</li>
							<li>
								<div class="inline-filed" v-if="optionNumShow">
									<el-form-item label="期权授予数量：">
										<el-input v-model="applyData.optionNum" :disabled="isDetail" placeholder="0" @input="applyData.optionNum=applyData.optionNum.replace(/[^\d]/g,'')" :maxlength="15"></el-input>
									</el-form-item>
								</div>
								<div class="inline-filed">
									<el-form-item label="是否享受双外补助："
										v-if="applyData.emplType==='37'"
									  	prop="shareSubsidy">
										<el-switch
											v-model="applyData.shareSubsidy"
											active-value="Y"
											inactive-value="N"
											:disabled="isDetail || isSubsidyFlag"
											>
										</el-switch>
									</el-form-item>
								</div>
							</li>
						</ul>
					</div>
				</div>
				<!-- 社保公积金信息 -->
				<div class="con-filed" v-if="socailFlag === 'Y'">
					<div class="con-title">社保公积金信息</div>
					<SocialInfo
						:applyData="applyData"/>
				</div>
				<!-- 附件 -->
				<div class="con-filed">
					<div class="con-title">附件</div>
					<Attachment
						:isDetail="isDetail"
						:applyData="applyData"/>
				</div>
				<div class="con-filed fixed-btn" v-if="!isDetail">
					<p class="submit-btn">
						<el-button type="warning" round size="small" :disabled="isDisabled"  @click="saveForm">
						保存</el-button>
						<el-button type="primary" round size="small" :disabled="isDisabled"  @click="submitForm('applyData')">
						提交</el-button>
						<el-button type="default" round size="small" @click="goExternalList">
						返回</el-button>
					</p>
				</div>
			</div>
		</el-form>
	</section>
</template>

<script>
import NativeApi from 'native-api'
import BaseInfo from '../../components/baseInfo.vue'
import JobInfo from '../../components/jobInfo.vue'
import SocialInfo from '../../components/apply/SocialInfo'
import Attachment from '../../components/apply/Attachment'
import { applySubmit, getDetailApply, getCompanyInfo, getEmpType, getSocialInfo, applySave } from '../../network'
import { staticList } from '../../network/staticList'

export default {
	name: 'apply',
	components: {
		BaseInfo,
		JobInfo,
		SocialInfo,
		Attachment,
	},
	data() {
		return {
			applyData: {
				company: '', // 合同主体
				emplType: '', // 人员类别
				emplTypeDescr: '',
				basePay: '', // 基本工资
				perfomPay: '', // 绩效工资
				totalPay: '', // 月工资
				yearBonusNum:'',//年终奖月数
				optionNum:'',//期权数量
				shareSubsidy:'',
				hrAttachs: [{
					pageModual: 'oth',
					attachModule: 'outside',
					delFlag: '0',
				}], // 附件
			},
			socailFlag: '', // 是否显示社保信息
			emplTypeTransCode: '', // 员工类别
			companyTypeList: [
				{
				companyCode:'',
				companyName:'',
				showFlag:''
				}
			],
			yearBonusMonthNumList: [],
			emplTypeList: [],
			typeCheck: false, // 用工类型检验
			baseCheck: false, // 基本信息检验
			jobCheck: false, // 任职信息检验
			isMobile: false, // 判断是否移动端
			isCheckId: false, // 判断是否通过身份验证
			isDisabled: false, // 防止提交成功重复点击
			isDetail: false, 
			isShowPay:'',
			isSubsidyFlag:true,
			getIsSubsidyParams : {
				workLocation:'',
				jobCode:'',
				emplType:'',
			},
			shareSubsidy:'',//是否享受双外补助：
			initData: {},
			optionNumShow: false,
		};
	},
	watch:{
		'applyData.emplType'(newData) {
			if (newData!=='37') {
				this.getIsSubsidyParams.jobCode = ''
				this.isSubsidyFlag = true;
				this.applyData.shareSubsidy = 'N'
			}
		}
	},
	computed: {
		allCount() {
			let allFee = Number(this.applyData.basePay) + Number(this.applyData.perfomPay)
			if(isNaN(allFee)){
				return '0.00'
			}
			allFee = (Math.round(allFee * 100) / 100).toFixed(2)
			this.applyData.totalPay = allFee
			let { accFoundMax, houseAccFundBase, curDownLimit } = this.applyData
			if (houseAccFundBase === 'MIN') { // 公积金基数是当地下限，取下限额
                this.applyData.houseAccFundBaseMax = curDownLimit
            } else if (houseAccFundBase === 'SAL') {
				if (accFoundMax < allFee) {
					this.applyData.houseAccFundBaseMax = accFoundMax
				} else if (allFee < curDownLimit) {
					this.applyData.houseAccFundBaseMax = curDownLimit
				} else {
					this.applyData.houseAccFundBaseMax = allFee
				}
			}
			return allFee
		},
	},
	created() {
		this.isDetail ? document.title = '外部用工详情' : document.title = '外部用工申请'
		this.yearBonusMonthNumList = staticList.yearBonusMonthNumList
		// 判断是否移动端
		this.isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
		if(this.isMobile){
			document.body.className = 'mobile'
		}
		//如果是详情页
		const { query, optionNumShow } = this.$route
		this.optionNumShow = optionNumShow === 'true'
		if(query && query.bizId) {
			this.isDetail = query.type !== 'edit' ? true : false
			this.getDetailApply()
		}else{
			this.isDetail = false;
			// 合同主体
			this.fetchCompanyList()
			// 员工类别
			this.fetchEmpTypeList()
		}
	},
	methods: {
		getIsSubsidyFlag(data){
			this.isSubsidyFlag = true
			this.applyData.shareSubsidy = 'N'
			this.getIsSubsidyParams[data.code] = data.val
			setTimeout(()=>{
				if(this.getIsSubsidyParams.workLocation !== '' && this.getIsSubsidyParams.jobCode !== '' && this.getIsSubsidyParams.emplType !== ''){
					getSocialInfo(this.getIsSubsidyParams).then((data)=>{
						let shareSubsidy = data.data.data.shareSubsidy
							shareSubsidy === 'Y' ? this.isSubsidyFlag = false : this.isSubsidyFlag = true
					})
				}
			},1000)
		},
		// 人员选择
		empTypeChange(code){
			const itemList = this.emplTypeList.filter(item => item.emplTypeCode === code)
			let item = itemList && itemList.length ? itemList[0] : {}
			let { emplTypeCode, socailFlag, emplTypeTransCode, emplTypeName } = item
			this.applyData.emplTypeDescr = emplTypeName
			this.socailFlag = socailFlag
			this.emplTypeTransCode = emplTypeTransCode
			if(emplTypeCode !== ''){
				this.$refs.JobInfo.resetJob()
				this.changeJobInfo({
					socialInsuranceLocation: '',
					socialInsuranceLocationDescr: '',
					beRegularEmpPay: '',
					socialInsuranceBase: '',
					accidentInsurance: '',
					accidentInsuranceMedicine: '',
					houseAccFundBase: '',
					houseAccFundBaseMax: '',
					accFoundMax: 0,
					curDownLimit: 0,
				})
			}
			this.getIsSubsidyFlag({code:'emplType',val:item.emplTypeTransCode || ''})
		},
		// 合同主体
		fetchCompanyList(){
			// NB 内部，WB 外部
			getCompanyInfo({ companyNature: 'WB' }).then((res) => {
				let data = res.data
				if(data.code === 'S00000'){
					this.companyTypeList = data.data || [];
				} else {
					this.$message.error(data.message)
				}
			}).catch(() => {})
		},
		// 员工类别
		fetchEmpTypeList(){
			let { company } = this.applyData
			getEmpType({ company }).then((res) => {
				let data = res.data
				if(data.code === 'S00000'){
					this.emplTypeList = data.data || [];
				} else {
					this.$message.error(data.message)
				}
			}).catch(() => {})
		},
		changeCompany(val){
			// 根据合同主体请求员工类别接口
			this.fetchEmpTypeList()
			this.applyData.emplType = ''
			this.applyData.emplTypeDescr = ''
			this.socailFlag = ''
			this.emplTypeTransCode = ''
			var companyInfo = this.companyTypeList.filter(n => n.companyCode === val);
			this.isShowPay = ((companyInfo.length&&companyInfo[0].showFlag === 'Y')
			 ? true: false)
			if(this.isShowPay==false){
				this.$set(this.applyData, 'basePay', '');
				this.$set(this.applyData, 'perfomPay', '');
			 }
		},
		showPayDiv(val){
			var companyInfo = this.companyTypeList.filter(n => n.companyName === val);
			this.isShowPay = ((companyInfo.length&&companyInfo[0].showFlag === 'Y')
			 ? true: false)
		},
		// 获取详情接口
		getDetailApply(){
			return getDetailApply({bizId: this.$route.query.bizId}).then((res)=>{
				let data = res.data
				if(data.code === 'S00000'){
					this.applyData = data.data[0]
					const { socailFlag, showFlag, emplTypeTransCode, nameAc } = this.applyData
					this.socailFlag = socailFlag
					this.isShowPay = showFlag === 'Y'
					this.emplTypeTransCode = emplTypeTransCode
					this.applyData.fullName = nameAc
					if(!this.applyData.basePay){
						this.applyData.basePay = '0'
					}
					if(!this.applyData.totalPay){
						this.applyData.totalPay = '0'
					}
					if(!this.applyData.perfomPay){
						this.applyData.perfomPay = '0'
					}
					this.initData = JSON.parse(JSON.stringify(this.applyData))
					if (this.$route.query && this.$route.query.type === 'edit') {
						// 合同主体
						this.fetchCompanyList()
						// 员工类别
						this.fetchEmpTypeList()
						if (this.socailFlag === 'Y') {
							this.getSalary()
						}
					}
				}else{
					this.$message.error(data.message)
				}
			}).catch((error)=>{
				//this.$message.error(JSON.stringify(error))
			})
		},
		async getSalary() {
			const { jobCode, location, emplTypeTransCode } = this.applyData
			if (jobCode && location && emplTypeTransCode) {
				let res = await getSocialInfo({
					jobCode,
					workLocation: location,
					emplType: emplTypeTransCode,
				}).catch()
				if (!res) return
				let { houseAccFundBaseMax, houseAccFundBase, curDownLimit } = res.data.data
				this.applyData.accFoundMax = houseAccFundBaseMax || 0
				this.applyData.houseAccFundBase = houseAccFundBase || ''
				this.applyData.curDownLimit = curDownLimit || 0
			}
		},
		changeBaseInfo(data) {
			this.applyData = Object.assign({}, this.applyData, data)
		},
		changeJobInfo(data) {
			this.applyData = Object.assign({}, this.applyData, data)
		},
		// 获取基本信息校验结果
		getBaseCheck(data){
			this.baseCheck = data
		},
		// 获取工作信息校验结果
		getJobCheck(data){
			this.jobCheck = data
		},
		// 报存前校验
		async saveForm(val) {
			let promise = new Promise((resolve, reject) => {
				this.$refs.baseInfo.saveBase()
				this.$refs.JobInfo.saveJobData()
				resolve(true)
			})
			let result = await promise
			if(result){
				this.save()
			}
		},
		save() {
			if (this.isCheckId) {
				if (!this.isShowPay) {
					this.applyData = Object.assign(this.applyData, { basePay: '', perfomPay: '' })
				}
				let hrAttachs = [...this.applyData.hrAttachs]
				hrAttachs = hrAttachs.filter(item => item.fileUniqueId)
				this.applyData.hrAttachs = hrAttachs
				this.isDisabled = true
				applySave(this.applyData).then((res)=>{
					let data = res.data
					if(data.code === 'S00000') {
						this.$confirm('', '保存成功，是否继续填写？', {
							confirmButtonText: '继续填写',
							cancelButtonText: '返回',
							confirmButtonClass: 'confirm-submit_btn',
							cancelButtonClass: 'goback_btn',
							type: 'success',
							center: true
						}).then(() => {
							// 调用详情接口继续填写
							this.$router.replace({
								name: 'ExternalApply',
								query: {
									bizId: data.data.bizId,
									type: 'edit'
								}
							})
							window.location.reload()
						}).catch(() => {
							this.goExternalList()
						})
					}else{
						this.$message.error(data.message)
					}
				}).catch((error)=>{
					this.$msgbox.alert(error.response.data.message, '提示', {
						confirmButtonText: '确定',
					})
				}).finally(() => {
					this.isDisabled = false
				})
			} else {
				this.$message.warning('身份验证未通过，请验证身份')
			}
		},
		goExternalList() {
			// pc端跳转
			if(!this.isMobile){
				this.$router.push({
					name: 'ExternalQuery',
				})
			}else{
				this.isDetail = true
				setTimeout(()=>{
					NativeApi.invoke('close', null, () => {})
				},1000)	
			}
		},
		// 提交前校验
		async submitForm(val) {
			let promise = new Promise((resolve, reject) => {
				this.$refs[val].validate((valid) => {
					if (valid) {
						this.typeCheck = true
					}else{
						this.typeCheck = false
					}
				})
				this.$refs.baseInfo.validateBase()
				this.$refs.JobInfo.validateJob()
				resolve(true)
			})
			let result = await promise
			if(result){
				this.submit()
			}
		},
		checkId(data){
			this.isCheckId = data
		},
		/* 提交 */
		submit(){
			// 如果校验全部通过	
			if (this.typeCheck && this.baseCheck && this.jobCheck) {
				if(this.isCheckId) {
					if (!this.isShowPay) {
						this.applyData = Object.assign(this.applyData, { basePay: '', perfomPay: '' })
					} else {
						if(this.applyData.basePay === '0.00' || this.applyData.basePay === ''){
							this.$message.error('基本工资不能为0')
							return
						}
					}
					// if(this.applyData.perfomPay === ''){
					// 	this.applyData.perfomPay = '0.00'
					// }
					// 校验附件
					let hrAttachs = [...this.applyData.hrAttachs]
					let { company } = this.applyData
					hrAttachs = hrAttachs.filter(item => item.fileUniqueId)
					// if (company === 'V01' && hrAttachs.findIndex((item) => item.pageModual === 'back_check') === -1) {
					// 	this.$message.warning('请上传背调授权书')
					// 	return
					// }
					this.applyData.hrAttachs = hrAttachs
					let params = this.applyData
					
					this.isDisabled = true

					return applySubmit(params).then((res)=>{
						let data = res.data
						if(data.code === 'S00000') {
							this.$message.success('提交成功')
							// pc端跳转
							if(!this.isMobile){
								this.$router.push({
									name: 'ExternalQuery',
								})
							}else{
								this.isDetail = true
								setTimeout(()=>{
									NativeApi.invoke('close', null, () => {})
								},1000)	
							}
							
						}else{
							this.$message.error(data.message)
						}
					}).catch((error)=>{
						this.$msgbox.alert(error.response.data.message, '提示', {
                            confirmButtonText: '确定',
                        })
					}).finally(() => {
						this.isDisabled = false
					})
				}else{
					this.$message.warning('身份验证未通过，请验证身份')
				}
			}else{
				this.$message.warning('填写信息有误，请检查')
				this.typeCheck = false 
				this.baseCheck = false
				this.jobCheck = false
			}
		},
		// 校验是否数字
		_checkRate(input) {
            let re = /^[0-9]+.?[0-9]*$/ // 判断字符串是否为数字 //判断正整数 /^[1-9]+[0-9]*]*$/
            if (!re.test(input)) {
                return false
            }
            return true
		},
		_parseFloat(valString) {
            if (!valString) {
                return 0
            }
            return parseFloat(valString)
        },
		// 输入框保留两位小数
        numToFixed(val,filed) {
			let inputValue = this._parseFloat(val).toFixed(2)
            if (this._checkRate(inputValue) && this.applyData[filed] != '') {
				this.applyData[filed] = inputValue
            } else {
                this.applyData[filed] = ''
            }
        },
	},
}
</script>
<style>
*{
  margin:0;
  padding:0;
}
ul,li{
  list-style: none;
}
</style>
<style lang="scss" >
  .pc-wrap{
	  background-color:#fff;
  }
  .external-container .el-input{
    width: 263px;
  }
  .external-container .field-radio{
    width: 263px;
  }
  .external-container .el-button.is-round{
    width: 80px;
  }
  .external-container{
    width: 1222px;
	padding-bottom: 90px;
	margin: 0 auto;
	.el-form-item{
		margin-bottom: 13px;
	}
	.el-form-item__error{
		padding-top:0;
	}
    .el-form-item__label,
    .el-form-item__content{
      display:inline-block;
    }
    .el-form-item__label{
      width: 120px;
      color: #9298A8;
      padding-right: 3px;
	  white-space: nowrap;
    }
    .el-date-editor.el-input{
      width: 263px;
    }
    .con-filed{
    	padding:0 60px;
    &.one-filed{
      .el-input{
        width: 350px;
      }
    }
    .con-title{
      margin: 0 0 17px 0;
      color: #344B58;
      font-size: 14px;
      padding-left: 9px;
      position: relative;
      &::after{
        content:'';
        position: absolute;
        width:4px;
        height:12px;
        background:url('../../assets/title-bg.png') no-repeat;
        left: 0;
        top: 4px;
		background-size: 4px 12px;
      }
    }
    .con-list{
      margin-bottom:21px;
      ul{
		padding-left:40px;
		li .inline-filed:nth-child(1) {
			margin-right: 20px;
		}
        .inline-filed{
          display:inline-block;
        }
      }
      .label-tit{
        display:inline-block;
        width: 120px;
        text-align:right;
        color: #9298A8;
        font-size:14px;
      }
      }
    }
    .header{
      height: 68px;
	  text-align: center;
	  margin-top: 70px;
	  border-bottom: 1px dashed #E5E5E5;
	  position: relative;
	  display: flex;
	  align-items: flex-end;
	  justify-content: center;
	  &::after, &::before{
		  content:'';
		  position: absolute;
		  z-index: 10;
		  width: 16px;
		  height: 16px;
		  background-color: #f2f4f6;
		  border-radius: 50%;
		  right: -8px;
    	  top: 59px;
	  }
	  &::before{
		  left: -8px;
		  right: initial;
	  }
	  .header-inner{
		  width: 70%;
	  }
      span{
        font-size: 16px;
        font-weight: bold;
		display: block;
		width: 100%;
      }
	  .header-bizId{
		  font-size: 12px;
		  text-align: right;
		  margin-bottom: 6px;
	  }
    }
    .submit-btn{
        text-align: center;
		padding: 13px 0 50px;
		text-align: center;
		position: fixed;
		bottom: 0;
		width: 1222px;
		left: 50%;
		margin-left: -610px;
		z-index: 10;
		background: #fff;
    }
    .cash-filed{
      .el-input{
        margin-bottom: 30px;
      }
    }
  }
  .pc-wrap.external-container{
	.el-form-item__label{
      width: 180px;
    }
  }

 
  .el-message{
	  top:80px!important;
  }
  .el-message-box__btns .confirm-submit_btn{
	  margin-left: 20px!important;
	  min-width: 80px;
	  border-radius: 24px;
  }
  .el-message-box__btns .goback_btn{
	  min-width: 80px;
	  border-radius: 24px;
  }
</style>
